import { Link, useLocation } from "react-router-dom"
import { LayoutDashboard, MapPin, AlertTriangle, Settings, Shield } from "lucide-react"

const Sidebar = () => {
  const location = useLocation()

  const menuItems = [
    { path: "/", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/devices", icon: MapPin, label: "Devices" },
    { path: "/alerts", icon: AlertTriangle, label: "Alerts" },
    { path: "/admin", icon: Settings, label: "Admin" },
  ]

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="flex items-center">
          <Shield className="h-8 w-8 text-blue-400" />
          <div className="ml-3">
            <h1 className="text-xl font-bold">SurakshaNet</h1>
            <p className="text-xs text-gray-400">Security Platform</p>
          </div>
        </div>
      </div>

      <div className="sidebar-content custom-scrollbar">
        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-nav-item ${isActive ? "sidebar-nav-item-active" : "sidebar-nav-item-inactive"}`}
              >
                <Icon className="sidebar-nav-icon" />
                <span>{item.label}</span>
              </Link>
            )
          })}
        </nav>
      </div>

      <div className="sidebar-footer">
        <div className="bg-gray-800 rounded-md p-4">
          <h3 className="text-sm font-medium text-gray-300 mb-2">System Status</h3>
          <div className="flex items-center">
            <div className="status-indicator status-active mr-2"></div>
            <span className="text-sm text-gray-400">All Systems Online</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar

